var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-testid":"component-selector"}},[(_vm.isMobile)?_vm._t("mobile"):_vm._e(),(!_vm.isMobile)?_vm._t("desktop"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }